import { delay } from '@/helpers/util'
import { getActiveToken } from '@/composables/useCurrentUserData'
import router from '@/router'


export default async function addTokenToUrl (name: string, urlQuery = {}) {
    await delay()
    if (name === 'generate-pdf') {
        return
    }
    const activeToken = getActiveToken()

    router.push(
        {
            query: {
                ...urlQuery,
                token: activeToken,
            },
        },
    ).catch((e) => {
        console.warn(e)
    })
}
